export default __webpack_public_path__ + "static/media/elePerson_2_1.58ee68da.png";